'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = search;
exports.activateSearch = activateSearch;
exports.deactivateSearch = deactivateSearch;
exports.updateSearch = updateSearch;
exports.clearSearch = clearSearch;
var ACTIVATE_SEARCH = 'ACTIVATE_SEARCH';
var DEACTIVATE_SEARCH = 'DEACTIVATE_SEARCH';
var UPDATE_SEARCH = 'UPDATE_SEARCH';
var CLEAR_SEARCH = 'CLEAR_SEARCH';

var initialState = {
  active: false,
  value: ''
};

function search() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case ACTIVATE_SEARCH:
      return _extends({}, state, {
        active: true
      });
    case DEACTIVATE_SEARCH:
      return _extends({}, state, {
        active: false
      });
    case UPDATE_SEARCH:
      return _extends({}, state, {
        active: true,
        value: action.value
      });
    case CLEAR_SEARCH:
      return _extends({}, state, {
        active: false,
        value: action.value
      });
    default:
      return state;
  }
}

function activateSearch() {
  return {
    type: ACTIVATE_SEARCH
  };
}

function deactivateSearch() {
  return {
    type: DEACTIVATE_SEARCH
  };
}

function updateSearch(value) {
  return {
    type: UPDATE_SEARCH,
    value: value
  };
}

function clearSearch() {
  return {
    type: CLEAR_SEARCH,
    value: ''
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 182
// module chunks = 0